import React, { useCallback } from 'react'
import AsyncPage from 'pages/AsyncPage'
import prepareTertiaryContent from './tertiary_content'
import { loadPublishedPosts, loadPublishedResponses } from 'state/actions/posts'
// todo: pull up to AsyncPage
import universal from 'react-universal-component'
import { useDispatch, useSelector } from 'react-redux'
import { useReduxLocation } from 'navigation/profile.selectors'
import { useCreation } from 'ahooks'
import { bindActionCreators } from 'redux'
const component = universal(props => import('./MyProfilePage'))
// const ExtraNav = universal(props => import('./MyProfilePageExtraNav'))

export const useProfileSearchAction = (): { searchAction } => {
  const { type } = useReduxLocation()
  const dispatch = useDispatch()
  const searchAction = useCreation(() => {
    let searchAction
    switch (type) {
      case 'profile/public/posts':
        searchAction = loadPublishedPosts
        break
      case 'profile/public/responses':
        searchAction = loadPublishedResponses
        break
    }

    if(!searchAction) {
      return null
    }
    return bindActionCreators(searchAction, dispatch)
  }, [type, dispatch])

  return { searchAction }
}

class AsyncMyProfilePage extends AsyncPage {
  constructor() {
    super({
      pageComponent: component
    })
  }
  async prepareAdditionalAsyncData(dispatch, getState, opts) {
    const {
      session: { value: profile },
      location: { type: place }
    } = getState()
    if (profile) {
      await prepareTertiaryContent(profile, place, dispatch, getState, opts)
    }
  }
  // getExtraSecondaryNavigation({ place }) {
  //   let searchAction = null
  //   switch (place.type) {
  //     case 'profile/public/posts':
  //       searchAction = loadPublishedPosts
  //       break
  //     case 'profile/public/responses':
  //       searchAction = loadPublishedResponses
  //       break
  //   }
  //   return <ExtraNav searchAction={searchAction} />
  // }
}

export default new AsyncMyProfilePage()
